'use client';

import { useState, useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * True for the lifetime of a component whose first render hydrated
 * server-rendered HTML. Entrance animations must skip in that case: the
 * server renders their `initial` state (often `opacity: 0`), so content the
 * server already painted would vanish until the client animates it back.
 * Captured once per mount, so it never flips while the component is mounted.
 */
export function useServerRenderedMount(): boolean {
  const hydrating = useSyncExternalStore(
    subscribe,
    () => false,
    () => true
  );
  const [serverRendered] = useState(hydrating);
  return serverRendered;
}

/**
 * True while React renders on the server or hydrates server HTML, false in
 * every later render. Text that depends on the browser (its time zone, say)
 * must wait for false, or hydration sees different text than the server sent.
 */
export function useIsHydrating(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => false,
    () => true
  );
}
